import React from 'react';
import { Button, Container, Card, Typography, Box, Grid, Chip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StepperSidebar, { EXAM_STEPS } from '../shared/imageWizard/StepperSidebar';

const warmColor = '#e67e22';
const warmColorLight = '#fdf2e9';
const warmColorDark = '#d35400';

function SelectBaseDc(props) {

    const onClickDcExamUnimibV2 = () => {
        props.setUseStandardCluster(false);
        props.handleSelectDc('examunimibv2')
    }

    const onClickDcUnimibV2 = () => {
        props.setUseStandardCluster(true);
        props.handleSelectDc('unimibv2')
    }

    return (
        <Container maxWidth="lg">
            <Box mb={3}>
                <Typography variant="h6" fontWeight="bold">
                    Seleziona il Datacenter
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Scegli l'infrastruttura su cui creare il laboratorio
                </Typography>
            </Box>

            <Card sx={{ p: 3, borderRadius: 3 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>

                        {/* === SEZIONE VER.2 - CONSIGLIATO === */}
                        <Box mb={1} display="flex" alignItems="center" gap={1}>
                            <Typography variant="h6" fontWeight="bold" sx={{ color: warmColor }}>
                                Infrastruttura Ver. 2
                            </Typography>
                            <Chip
                                icon={<StarIcon />}
                                label="Upgrade"
                                size="small"
                                sx={{
                                    bgcolor: warmColor,
                                    color: '#fff',
                                    '& .MuiChip-icon': { color: '#fff' },
                                    fontWeight: 600,
                                }}
                            />
                        </Box>
                        <Typography variant="body2" color="text.secondary" mb={2}>
                            Nuova infrastruttura con prestazioni migliorate
                        </Typography>

                        <Grid container spacing={3} mb={4}>
                            <Grid item xs={12} sm={6}>
                                <Card variant="outlined" sx={{
                                    p: 3,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    borderColor: warmColor,
                                    borderWidth: 2,
                                    borderRadius: 3,
                                    bgcolor: warmColorLight,
                                    cursor: 'pointer',
                                    transition: 'all 0.25s ease',
                                    '&:hover': {
                                        boxShadow: `0 8px 24px rgba(230, 126, 34, 0.2)`,
                                        transform: 'translateY(-2px)',
                                    },
                                }}
                                    onClick={onClickDcExamUnimibV2}
                                >
                                    <Box>
                                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                                            Esami Bicocca Ver. 2
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Laboratorio su infrastruttura Bicocca Ver. 2 per esami ad accesso privato
                                        </Typography>
                                    </Box>
                                    <Button
                                        variant="contained"
                                        component="div"
                                        size="large"
                                        fullWidth
                                        sx={{
                                            mt: 2,
                                            bgcolor: warmColor,
                                            fontWeight: 600,
                                            fontSize: '1rem',
                                            py: 1.2,
                                            borderRadius: 2,
                                            '&:hover': { bgcolor: warmColorDark },
                                        }}
                                    >
                                        Seleziona
                                    </Button>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Card variant="outlined" sx={{
                                    p: 3,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    borderColor: warmColor,
                                    borderWidth: 2,
                                    borderRadius: 3,
                                    bgcolor: warmColorLight,
                                    cursor: 'pointer',
                                    transition: 'all 0.25s ease',
                                    '&:hover': {
                                        boxShadow: `0 8px 24px rgba(230, 126, 34, 0.2)`,
                                        transform: 'translateY(-2px)',
                                    },
                                }}
                                    onClick={onClickDcUnimibV2}
                                >
                                    <Box>
                                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                                            Lezioni Bicocca Ver. 2
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Laboratorio su infrastruttura Bicocca Ver. 2 per lezione (emergenza) - Il laboratorio esame verrà creato sul cluster lezione ad accesso pubblico invece che sul cluster esame
                                        </Typography>
                                    </Box>
                                    <Button
                                        variant="contained"
                                        component="div"
                                        size="large"
                                        fullWidth
                                        sx={{
                                            mt: 2,
                                            bgcolor: warmColor,
                                            fontWeight: 600,
                                            fontSize: '1rem',
                                            py: 1.2,
                                            borderRadius: 2,
                                            '&:hover': { bgcolor: warmColorDark },
                                        }}
                                    >
                                        Seleziona
                                    </Button>
                                </Card>
                            </Grid>
                        </Grid>

                    </Grid>

                    {/* === STEPPER LATERALE === */}
                    <Grid item xs={12} md={4}>
                        <StepperSidebar currentStep={1} statusForm={props.statusForm} steps={EXAM_STEPS} />
                    </Grid>
                </Grid>
            </Card>
        </Container>
    );
}

export default SelectBaseDc;
